import UsersService from '@/services/users.service';
import ApiService from '@/services/api.service';
import  JwtDecode from 'jwt-decode';
import JwtService from '@/services/jwt.service';
import WebSocketClient from "@/lib/websocket-client";
import {API_URL} from '@/services/api.service';
const webSocketClient = new WebSocketClient(API_URL + "/ws");


export default {
  aSignUp({commit}, payload) {
    return new Promise((resolve, reject) => {
     UsersService.signUp(payload).then(function(response) {
       resolve();
     }).catch(function(err) {
       reject();
     });

  });
  },
  aSignIn({commit}, payload) {
    return new Promise((resolve, reject) => {
      UsersService.signIn(payload).then(function(response) {
        commit('mSetAuth', response.data);
        resolve();
      }).catch(function(err) {
        reject();
      });
    });
  },
  aLogout({commit}) {
    commit('mPurgeAuth');
  },
  aSubscribe({state}, payload) {
    
    const user = state;
    // console.log("user", user);
    if(user) {
      webSocketClient.connect();
      webSocketClient.subscribe(payload.id, '/user/' + user.user.id + payload.endpoint, payload.onMessageReceived, typeof payload.renew != "undefined" ? payload.renew : false);
    }
    // (subscriberId, endpoint, onMessageReceived, renew = false)
    
    //const webSocketClient = state.webSocketClient;
    // commit('mPurgeAuth');
  },
  aCheckAuth({commit}) {
   if (JwtService.getToken()) {
     ApiService.setHeader();
   } else {
     commit('mPurgeAuth');
   }
 }
}
